import React from 'react'
import { ImageSourcePropType } from 'react-native'
import { useNavigate } from 'react-router-dom'

import styled, { useTheme } from 'styled-components/native'

import smartSchedulingBackground from '@lyrahealth-inc/ui-core-crossplatform/src/assets/smartSchedulingBackground@2x.png'
import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { Display } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/display/Display'
import { PrimaryButton } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/primaryButton/PrimaryButton'
import { Title } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/title/Title'
import { BodyTextSize, DisplaySize, TitleSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { ContentContainer } from '@lyrahealth-inc/ui-core-crossplatform/src/templates/content/ContentContainer'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import { actions, mixpanelEvents } from '../../../../mixpanel/mixpanelConstants'
import { track } from '../../../../mixpanel/mixpanelTracking'
import { SCHEDULING_ACTIVATE } from '../../common/constants/routingConstants'
import { DescriptionContainer, LandingHeaderContainer, LandingTitleContainer, SchedulingCTAWrapper } from '../constants'

const TitleImageBackgroundContainer = styled.View({
  height: '100vh',
})

const ImageBackgroundLC = styled.ImageBackground({
  height: '100%',
})

export const SchedulingLandingBodyLC: React.FC = () => {
  const { colors } = useTheme()
  const navigate = useNavigate()

  const onStartConnecting = () => {
    track({ event: mixpanelEvents.BUTTON_PRESS, action: actions.CONNECT_CALENDAR_START })
    navigate(SCHEDULING_ACTIVATE.route)
  }

  return (
    <TitleImageBackgroundContainer>
      <ImageBackgroundLC source={smartSchedulingBackground as ImageSourcePropType} accessibilityIgnoresInvertColors>
        <ContentContainer>
          <LandingHeaderContainer>
            <Display level='2' size={DisplaySize.SMALL} text='Calendar' color={colors.textPrimary} />
          </LandingHeaderContainer>
        </ContentContainer>
        <ContentContainer>
          <SchedulingCTAWrapper>
            <LandingTitleContainer>
              <Title level='3' color={colors.textPrimary} size={TitleSize.MEDIUM} text='Activate Smart Scheduling' />
            </LandingTitleContainer>
            <DescriptionContainer>
              <BodyText
                color={colors.textSecondary}
                size={BodyTextSize.SMALL}
                text='Connect your calendar to Lyra so your future clients can book their sessions with you easily and quickly.'
              />
            </DescriptionContainer>
            <PrimaryButton
              text='Get started'
              onPress={onStartConnecting}
              testID={tID('SchedulingLandingBodyLC-startWalkthrough')}
            />
          </SchedulingCTAWrapper>
        </ContentContainer>
      </ImageBackgroundLC>
    </TitleImageBackgroundContainer>
  )
}
